import {TerminalRoute} from "../../stemjs/src/ui/Router.jsx";
import {IEEEXtremeContestPage} from "./IEEEXtremeContestPage.jsx";
import {PreXtremeContestPage} from "./PreXtremeContestPage.jsx";

export class IEEEXtremeContestRoute extends TerminalRoute {
    constructor(options={}) {
        super("ieeextreme", IEEEXtremeContestPage, options);
    }

    matches(urlParts) {
        const contestName = urlParts[0];

        if (!contestName?.startsWith("ieeextreme")) {
            return null;
        }

        return {
            args: contestName,
            urlParts: urlParts.slice(1),
        }
    }
}

export class PreXtremeContestRoute extends TerminalRoute {
    constructor(options={}) {
        super("prextreme", PreXtremeContestPage, options);
    }

    matches(urlParts) {
        const contestName = urlParts[0];

        if (!contestName?.startsWith("prextreme")) {
            return null;
        }

        return {
            args: contestName,
            urlParts: urlParts.slice(1),
        }
    }
}
